import env from "../config.json"

import { METHODS } from '../const/config';

const { BASE_URL } = env;
// const token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NGUzNTRhOGIzMGVkMzIxODc5YjNjNjEiLCJpYXQiOjE3MTc5OTU0NDYsImV4cCI6MTcxNzk5OTA0Nn0.qeKkYoDNLxnxLclCOQ8l94PAaHId4u4FLxx1myX570g'
// const token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiI2NGUzNTRhOGIzMGVkMzIxODc5YjNjNjEiLCJpYXQiOjE3MTM1MTUzNTYsImV4cCI6MTcxMzUxODk1Nn0.0ZQT0Yfsf1TTdP_dL-RaQH0hsUlLtGlpLK-5fpzr44k'
const token1= 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c'

const token='eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjcmVhdGVkX2F0IjoxNzQ0NzgxMTc5Mjc5LCJ1cGRhdGVkX2F0IjoxNzQ0NzgxMjI2OTY5LCJpZCI6IjY3ZmYzZjdiOTJjMmZhMzBhNjQwNjc1NSIsImZpcnN0X25hbWUiOiJBa2hpbGVzaCBXTUQgVGVzdCIsImxhc3RfbmFtZSI6IiIsImNvdW50cnlDb2RlIjo5MSwicGhvbmVfbnVtYmVyIjo5OTcyMTUxNTE4LCJkZXZpY2VfbnVtYmVyIjoiV0VCLURFVklDRS0xMjM0NTYiLCJlbWFpbF9pZCI6IiIsImF2YXRhcl91cmwiOiIiLCJnZW5kZXIiOiIiLCJkb2IiOm51bGwsInByZWZlcnJlZExhbmd1YWdlIjoiZW4tVVMiLCJwYXNzd29yZCI6IiQyYiQxMCRuV3l2YW9WeHQ4bGJ2WjhzYThxbWhPczFaSWhIT3ZXSFl6Ri5DWmRyLzY4a2FyTk5GLnhpcSIsIm90cCI6IjYzMDMiLCJvdHBNb2RlIjoiU01TIiwib3RwX2V4cGlyYXRpb24iOjE3NDQ3ODE3NzkyODUsImZjbV90b2tlbiI6IiIsImlzX25ld191c2VyIjpmYWxzZSwiaXNfdXNlciI6dHJ1ZSwiaXNfYWN0aXZlIjp0cnVlLCJpc190Y19hY2NlcHRlZCI6dHJ1ZSwiZGV2aWNlRGV0YWlscyI6eyJicm93c2VyIjoiTW96aWxsYS81LjAgKFdpbmRvd3MgTlQgMTAuMDsgV2luNjQ7IHg2NCkgQXBwbGVXZWJLaXQvNTM3LjM2IChLSFRNTCwgbGlrZSBHZWNrbykgQ2hyb21lLzEzNS4wLjAuMCBTYWZhcmkvNTM3LjM2IiwicGxhdGZvcm0iOiJXaW4zMiJ9LCJsYXN0QWNjZXNzZWQiOiIyMDI1LTA0LTE2VDA1OjI2OjE5LjAwMVoiLCJjdXJyZW50X2xvY2F0aW9uIjpudWxsLCJyYXRpbmciOjUsImVtZXJnZW5jeV9jb250YWN0IjoiIiwiZGVidWdfbGV2ZWwiOiIiLCJpYXQiOjE3NDk1NDU1OTUsImV4cCI6MTc4MTA4MTU5NX0.v4bWbLUnj-bId3mLlXI0puBfD9VX9B5OM3y7ClAJKKo'
function joinUrl(url) {
    return BASE_URL + url;
}

class Http{
    constructor() {
        // assign base url to local variable
        this.baseurl = BASE_URL;
    }

     // Helper function to get token from localStorage
    //  static getToken() {
    //     // Assuming token is stored under the key 'token'
    //     return localStorage.getItem('token');
    // }
    static getToken() {
        // Assuming token is stored under the key 'token'
        if(localStorage.getItem('token')){
            return localStorage.getItem('token');
        }
        else{
            return token;
        }
       
    }

   
    static async request(url, method, data) {
        // Get headers before API call
        // const headers = await getHeaders();
        console.log("data in request ",data)

         // Fetch the token from localStorage
         const token = this.getToken();

         
        // Create options for the API call
        const options = {
            method,
            headers: {
                'Content-Type': 'application/json', // Set Content-Type header to application/json
                'Authorization': `Bearer ${token}`
            },
            // headers,
        };

        // If data add it in to body
        // Stringfy the body
        if (data != null) {
            options.body = JSON.stringify(data);
            console.log("options.body",options.body)
            // console.log("data",data)
        }

        // Return fetch response
        // return fetch(url, options).then(res => {
        //     // console.log("res.json()",res.json())
        //     res.json();
        // });
        try {
            return fetch(url, options).then(res => res.json());
            // console.log("url in http ",url,options)
            // const response = await fetch(url, options);
            // console.log(
            //     "response in https",response
            // )
            // // await  console.log("response in http options",response.json());
            // const data = await response.json();
            // console.log("response in http data", data);
            // return data; // This will return the array
        } catch (err) {
            console.log("error in http", err);
            throw err; // Re-throw the error if needed
        }
      
       

    }



    // Post method
    static async post(url, data = {}) {
        console.log('in Http post ',joinUrl(url), METHODS.POST, data)
        return this.request(joinUrl(url), METHODS.POST, data);
    }
      // Get method
      static async get(url) {
        console.log('in Http get',joinUrl(url), METHODS.GET, )
        return this.request(joinUrl(url), METHODS.GET);
        // return fetch(url, METHODS.GET).then(res => res.json());
    }
     // Update method
     static async update(url, data = {}) {
        console.log("data in http ",data)
        return this.request(joinUrl(url), METHODS.PUT, data);
    }
    // Delete method
    static async delete(url) {
        console.log("url",url)
        return this.request(joinUrl(url), METHODS.DELETE);
    }
}
export default Http;